import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

function PriceCard() {
  return (
    <Card style={{ width: '40vw', color: "#676266", backgroundColor: "#c7afc3"}}>      
      <Card.Body>
        <Card.Title style={{ fontSize: "3.5vw",  fontWeight: "bold",}}>Einführungs-<br/>Preis</Card.Title> 
        <div style={{fontSize: "3.5vw", fontWeight: "bold"}}>79€</div>
        <br/>      
        <div className="row justify-content-center">                    
          <Button variant="primary" style={{backgroundColor: "#6083bf", borderColor: "#6083bf", fontSize: "2.5vw"}} href='/contact'>Hier geht's zum Kontaktformular</Button>                
        </div>         
      </Card.Body>
    </Card>
  );
}

export default PriceCard;